// extracted by mini-css-extract-plugin
export default {"root":"HasExpiredSubscriptionInformer__root--DpWw7","button":"HasExpiredSubscriptionInformer__button--1t3cj"};